var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.810923 2.3707L2.82945 7.13063L8.41938 7.66865C8.55282 7.6815 8.65421 7.80062 8.65424 7.94353C8.65426 8.08644 8.55292 8.20551 8.41949 8.2183L2.82978 8.75377L0.813154 13.5128C0.648302 13.8865 0.723978 14.3324 1.00236 14.6207C1.27444 14.9182 1.69364 14.9977 2.04523 14.8194L14.4085 8.7716C14.6605 8.64707 14.8397 8.39976 14.89 8.10907C14.9409 7.81776 14.8561 7.5185 14.663 7.30529C14.5886 7.2271 14.5027 7.16357 14.4082 7.11773L2.04408 1.06258C1.69128 0.891495 1.27611 0.971395 1.00243 1.26326C0.72818 1.55574 0.653252 1.99851 0.814253 2.37414L0.810923 2.3707Z",
    fill: "url(#paint0_linear_254_56)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_254_56",
    x1: 10.1301,
    y1: 2.47104,
    x2: -0.789392,
    y2: 12.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5765"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.cd24ea4e2d3f96fb87cfd02c3035bcdc.svg";
export { ForwardRef as ReactComponent };